import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconPopcornBag48(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="popcorn">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.1065 47.9942C18.5574 48.053 18.0645 47.6556 18.0057 47.1064L15.0057 19.1064C14.9469 18.5573 15.3444 18.0644 15.8935 18.0056C16.4427 17.9467 16.9355 18.3442 16.9944 18.8934L19.9943 46.8934C20.0531 47.4425 19.6557 47.9354 19.1065 47.9942Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24 19C24.5523 19 25 19.4477 25 20V46C25 46.5523 24.5523 47 24 47C23.4477 47 23 46.5523 23 46V20C23 19.4477 23.4477 19 24 19Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M28.0057 46.8935L31.0057 18.8935C31.0645 18.3444 31.5574 17.9469 32.1065 18.0058C32.6557 18.0646 33.0531 18.5575 32.9943 19.1066L29.9943 47.1066C29.9355 47.6558 29.4426 48.0532 28.8935 47.9944C28.3443 47.9356 27.9468 47.4427 28.0057 46.8935Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M28.5634 6.50667L27.6838 4.43723C27.0733 3.00098 25.6513 2 24 2C22.3487 2 20.9267 3.00098 20.3162 4.43723L19.4366 6.50667L17.4839 5.39172C17.0481 5.14287 16.5438 5 16 5C14.3431 5 13 6.34315 13 8C13 8.01685 13.0001 8.03363 13.0004 8.05036L13.0284 9.77082L11.3314 10.0553C9.44085 10.3723 8 12.0198 8 14C8 16.2091 9.79086 18 12 18H11.3609C10.4419 18 9.68652 18.6136 9.44306 19.4295C7.40816 18.4695 6 16.3992 6 14C6 11.0268 8.16263 8.55865 11.0007 8.08285C11.0002 8.05528 11 8.02767 11 8C11 5.23858 13.2386 3 16 3C16.4885 3 16.9607 3.07006 17.407 3.20068C17.7835 3.31088 18.1416 3.46418 18.4756 3.65489C18.6593 3.22261 18.8923 2.81632 19.1675 2.44306C20.26 0.961258 22.0178 0 24 0C25.9822 0 27.74 0.961256 28.8325 2.44305C29.1077 2.81632 29.3407 3.22261 29.5244 3.65489C29.8584 3.46418 30.2165 3.31088 30.593 3.20068C31.0393 3.07006 31.5115 3 32 3C34.7614 3 37 5.23858 37 8C37 8.02767 36.9998 8.05528 36.9993 8.08285C39.8374 8.55865 42 11.0268 42 14C42 16.3992 40.5918 18.4695 38.5569 19.4295C38.3135 18.6136 37.5581 18 36.6391 18H36C38.2091 18 40 16.2091 40 14C40 12.0198 38.5592 10.3723 36.6686 10.0553L34.9716 9.77081L34.9996 8.05033C34.9999 8.0336 35 8.01682 35 8C35 6.34315 33.6569 5 32 5C31.4562 5 30.9519 5.14287 30.5161 5.39172L28.5634 6.50667ZM35.1045 18L35.1562 17.9655L35.8116 17.9957C35.8739 17.9985 35.9367 18 36 18H35.1045ZM12.8955 18H12C12.0633 18 12.1261 17.9985 12.1884 17.9957L12.8438 17.9655L12.8955 18Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M36.6391 20H11.3609L15.6942 46H32.3057L36.6391 20ZM11.3609 18C10.125 18 9.18494 19.1097 9.38812 20.3288L13.7215 46.3288C13.8822 47.2932 14.7166 48 15.6942 48H32.3057C33.2834 48 34.1178 47.2932 34.2785 46.3288L38.6119 20.3288C38.815 19.1097 37.8749 18 36.6391 18H11.3609Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconPopcornBag24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="popcorn">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.92331 9.00295C9.47397 8.96059 9.9547 9.37265 9.99706 9.92331L10.9971 22.9233C11.0394 23.474 10.6274 23.9547 10.0767 23.9971C9.52604 24.0394 9.04531 23.6274 9.00295 23.0767L8.00295 10.0767C7.96059 9.52604 8.37265 9.04531 8.92331 9.00295Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.9233 23.9971C12.3726 23.9548 11.9606 23.474 12.0029 22.9234L13.0029 9.92335C13.0453 9.37269 13.526 8.96064 14.0767 9.00299C14.6273 9.04535 15.0394 9.52608 14.997 10.0767L13.997 23.0768C13.9547 23.6274 13.474 24.0395 12.9233 23.9971Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.01397 2.0376C7.69986 0.821571 9.00317 0 10.5 0C11.6733 0 12.7276 0.505294 13.4585 1.30812C13.9333 1.1097 14.4543 1 15 1C16.9579 1 18.5872 2.40665 18.9325 4.26446C20.4342 4.8407 21.5 6.29516 21.5 8C21.5 9.65897 20.4906 11.0814 19.0521 11.6875L19.1119 11.3288C19.2175 10.6951 19.0141 10.0909 18.6209 9.65678C19.1513 9.29705 19.5 8.68897 19.5 8C19.5 7.00993 18.7796 6.18615 17.8344 6.02767L16.9882 5.88579L16.9998 5.02788L17 5C17 3.89543 16.1046 3 15 3C14.5388 3 14.1165 3.15492 13.7785 3.41614L12.8293 4.14984L12.2786 3.08392C11.9449 2.43799 11.2727 2 10.5 2C9.56909 2 8.78442 2.63693 8.56269 3.50026L8.25777 4.68755L7.15591 4.15038C6.95895 4.05436 6.73724 4 6.5 4C5.67157 4 5 4.67157 5 5.5C5 5.68939 5.03462 5.86837 5.09699 6.03254L5.38665 6.79496L4.69804 7.232C4.27632 7.49966 4 7.96791 4 8.5C4 9.2085 4.49196 9.80337 5.15249 9.95975C4.91256 10.3527 4.80527 10.8316 4.88813 11.3288L5.10835 12.6501C4.88227 12.4052 4.68386 12.1418 4.51941 11.8605C3.06341 11.4363 2 10.0929 2 8.5C2 7.5266 2.39781 6.64654 3.03746 6.013C3.01276 5.84527 3 5.67394 3 5.5C3 3.567 4.567 2 6.5 2C6.67436 2 6.846 2.01282 7.01397 2.0376Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.5604 11L5.43961 11L7.63961 22L15.3604 22L17.5604 11ZM5.43961 9C4.17752 9 3.23094 10.1546 3.47845 11.3922L5.67845 22.3922C5.86542 23.3271 6.68625 24 7.63961 24H15.3604C16.3138 24 17.1346 23.3271 17.3216 22.3922L19.5216 11.3922C19.7691 10.1546 18.8225 9 17.5604 9H5.43961Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconPopcornBag16(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="popcorn">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.99999 16C7.4477 16 6.99999 15.5523 6.99999 15L6.99999 7C6.99999 6.44771 7.4477 6 7.99999 6C8.55227 6 8.99999 6.44771 8.99999 7L8.99999 15C8.99999 15.5523 8.55227 16 7.99999 16Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.51068 2.04344C5.19573 0.824093 6.50087 0 8 0C9.48164 0 10.7734 0.805082 11.4647 2.00018L11.5 2C13.433 2 15 3.567 15 5.5C15 7.0762 13.9581 8.40905 12.5254 8.84739L12.6119 8.32876C12.706 7.76379 12.5546 7.22231 12.2421 6.80389C12.6948 6.54568 13 6.05848 13 5.5C13 4.67157 12.3284 4 11.5 4C11.3651 4 11.2359 4.01755 11.1137 4.04995L10.1952 4.29357L9.90511 3.38861C9.64654 2.58194 8.88992 2 8 2C7.05374 2 6.25876 2.65813 6.05229 3.5427L5.73041 4.92171L4.53851 4.15709C4.38362 4.05773 4.20008 4 4 4C3.44772 4 3 4.44772 3 5C3 5.43669 3.28051 5.81044 3.67412 5.94599L4.25661 6.14657L4.27969 6.31666C3.63511 6.73209 3.25092 7.50549 3.38813 8.32876L3.49694 8.98161C3.05724 8.60538 2.69721 8.14204 2.49897 7.59775C1.60358 7.07935 1 6.11108 1 5C1 3.34315 2.34315 2 4 2C4.17387 2 4.34453 2.01488 4.51068 2.04344Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.5604 8H4.42554L5.59025 14L10.3604 14L11.5604 8ZM4.42554 6C3.16807 6 2.22257 7.14669 2.46219 8.38112L3.6269 14.3811C3.80938 15.3212 4.63263 16 5.59025 16H10.3604C11.3137 16 12.1346 15.3271 12.3215 14.3922L13.5215 8.39223C13.769 7.15465 12.8225 6 11.5604 6H4.42554Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
